/* eslint-disable no-undef */
/* eslint-disable no-control-regex */
import moment from 'moment';
import $ from 'jquery';
import 'jquery-modal';
import { isNil } from 'lodash';
import axios from 'axios';
import { debounce } from './_utilities/debounce';
import { setDevice } from './_utilities/devices';
import { customResizeEvent, favoriteLoaderClass } from './_helpers/constants';

export const setResizeEvent = () => {
  const resizeEvent = new Event(customResizeEvent);
  const sendEvent = debounce(
    () => {
      window.dispatchEvent(resizeEvent);
    },
    250,
    false
  );
  window.addEventListener('resize', sendEvent);
};

export const setDeviceType = () => {
  window.addEventListener(customResizeEvent, setDevice);
};

export function Warn(...args) {
  window.console && window.console.warn(...args);
}

export const watchAddedNodes = async (callback, querySelector, immediate = true) => {
  const throttle = await import('./_utilities/throttle');
  if (!callback || typeof callback !== 'function') throw new Error('callback must be a function');
  if (!querySelector) throw new Error('querySelector must have a value');

  if (immediate) {
    const initialElements = Array.from(document.querySelectorAll(querySelector));
    callback(initialElements);
  }

  const observer = new MutationObserver((mutationsList) => {
    let elements = [];
    const debouncedClbk = throttle.debounce(
      () => {
        callback(elements);
      },
      250,
      false
    );
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const nodes = Array.from(mutation.addedNodes).filter((node) => node.nodeType === 1);
        const selfNodes = nodes.filter((node) => !querySelector || node.matches(querySelector));
        const innerNodes = nodes
          .filter((node) => querySelector && node.querySelector(querySelector))
          .map((node) => Array.from(node.querySelectorAll(querySelector)))
          .reduce((a, b) => a.concat(b), []);
        elements = [...elements, ...selfNodes, ...innerNodes];
      }
    }

    if (elements && elements.length) {
      debouncedClbk();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true,
  });
  return observer;
};

export const getCurrentYearDays = () => {
  const date = new Date().getFullYear();
  return moment([date]).isLeapYear() ? 366 : 365;
};

export const resetSelect = (element) => {
  $(element).prop('selectedIndex', 0);
};

export const getCalendar = async (url) => {
  try {
    const resp = await axios.get(url);
    const existingFileName = resp.headers['content-disposition']
      .split('filename=')[1]
      .split(';')[0]
      .trim();
    const fileName =
      unescape(existingFileName)
        .replace(new RegExp('"', 'g'), '')
        .replace(/\s/g, '-')
        .replace(/,/g, '') + '.ics';
    downloadFile(resp, fileName);
  } catch {
    const html = `<div class="fm-card">
      <div class="fm-card__content">
          <h4> Calendar not found for this tournament</h4>
      </div>
  </div>`;
    $(html).appendTo('body').modal();
  }
};

const downloadFile = (resp, filename) => {
  const SEPARATOR = navigator.appVersion.indexOf('Win') !== -1 ? '\r\n' : '\n';
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const d = resp.data.replace(new RegExp('\r\n', 'g'), SEPARATOR);
    a.href = 'data:' + resp.headers['content-type'] + ';charset=utf8,' + escape(d);
    a.title = filename;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
};

export const manageLoader = (
  element,
  parent,
  oppsiteElement = null,
  show = true,
  showElementOnHide = false
) => {
  const loader = $(parent).find(favoriteLoaderClass);
  if (show) {
    $(element).hide();
    loader.show();
    return;
  }
  loader.hide();
  if (showElementOnHide) {
    $(element).show();
  }
  if (!isNil(oppsiteElement)) {
    $(oppsiteElement).show();
  }
};

export const arrayToList = (array) => {
  const list = [];
  if (array) {
    array.forEach((item) => {
      list.push(item.match(/\d+/g));
    });
  }
  return list;
};

export const getElementAttribute = (element, attr, defaultvalue) => {
  const value = $(element).attr(attr);
  return !isNil(value) && value !== '' ? value : defaultvalue;
};
